<div class="svg-loader">
    <object data="/old/cloudigo_loader.svg" type="image/svg+xml"></object>
</div>
<h1>cloudigo</h1>